import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/map.css";
import "./styles/app.css";

const root = document.getElementById("root");
if (!root) throw new Error("No #root element.");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
